import { useEffect, useState } from "react";
import { RuleGroup } from "../../types/Campaigns";
import useCampaignsService from "../../services/CampaignsService";
import { useNavigate } from "react-router-dom";
import PositiveButton from "../PositiveButton";
import RuleGroupOverlayForm from "./RuleGroupOverlayForm";
import RuleGroupListItem from "./RuleGroupListItem";

interface RewardRulesListProps {
  campaignId: string;
  rewardId: string;
}

export default function RewardRulesList({
  campaignId,
  rewardId,
}: RewardRulesListProps) {
  const [ruleGroups, setRuleGroups] = useState<RuleGroup[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { getRuleGroupsForReward } = useCampaignsService();
  const [selectedRuleGroupId, setSelectedRuleGroupId] = useState<
    string | undefined | null
  >(null);

  const navigate = useNavigate();

  const fetchRuleGroups = async () => {
    setIsLoading(true);
    try {
      const ruleGroupsData = await getRuleGroupsForReward(campaignId, rewardId);
      setRuleGroups(ruleGroupsData as RuleGroup[]);
    } catch (error) {
      console.error("Error fetching rule groups:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRuleGroups();
  }, [campaignId, rewardId, getRuleGroupsForReward]);

  return (
    <div className="grid grid-cols-1 gap-4">
      <div className="flex justify-between items-center">
        <h4 className="text-2xl mb-4">Reward Rules</h4>
        <div className="flex justify-end">
          <PositiveButton
            disabled={isLoading}
            className="btn btn-primary"
            onClick={() => {
              setSelectedRuleGroupId(undefined);
            }}
          >
            Create New Rule Group
          </PositiveButton>
        </div>
      </div>
      {isLoading ? (
        <p>Loading rule groups...</p>
      ) : ruleGroups.length > 0 ? (
        <table className="table-auto w-full card border-spacing-2">
          <thead>
            <tr className="">
              <th className="font-normal text-left p-4">Description</th>
              <th className="font-normal text-left p-4"></th>
            </tr>
          </thead>
          <tbody>
            {ruleGroups.map((ruleGroup) => (
              <RuleGroupListItem
                key={ruleGroup.id}
                campaignId={campaignId}
                rewardId={rewardId}
                ruleGroup={ruleGroup}
                onClick={() => {
                  setSelectedRuleGroupId(ruleGroup.id);
                }}
              />
            ))}
          </tbody>
        </table>
      ) : (
        <p>No rules found for this reward.</p>
      )}
      {selectedRuleGroupId !== null && (
        <RuleGroupOverlayForm
          campaignId={campaignId}
          rewardId={rewardId}
          ruleGroupId={selectedRuleGroupId}
          onUpdated={fetchRuleGroups}
          onClose={(updated) => {
            setSelectedRuleGroupId(null);
            if (updated) {
              fetchRuleGroups();
            }
          }}
        />
      )}
    </div>
  );
}
